export class PhoneNumberWithPrefix {
  public constructor(
    private readonly data: {
      prefix: string;
      number: string;
    },
  ) {}

  public get prefix(): string {
    return this.data.prefix;
  }

  public get number(): string {
    return this.data.number;
  }

  public get numberWithPrefix(): string {
    return `${this.prefix} ${this.number}`;
  }
}
